const indexHelp = () => import('./pages/IndexHelp.vue')
const contact = () => import('./pages/Contact.vue')
const questions = () => import('./pages/Questions.vue')

const faqsRoutes = [
  {
    path: 'help',
    name: 'help',
    component: indexHelp,
  },
  {
    path: 'contact',
    name: 'contactFaq',
    component: contact,
  },
  {
    path: 'questions/:contentName',
    name: 'questions',
    component: questions,
  },
]

export default faqsRoutes
